import { useEffect } from "react";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError
} from "react-router";
import errorMonitoring from "lib/errorMonitoring";
import FullErrorPage from "views/pages/fullErrorPage/FullErrorPage";

const routeErrorToError = (routeError: unknown): Error => {
  if (routeError instanceof Error) return routeError;

  if (isRouteErrorResponse(routeError)) {
    return new Error(
      `Route error ${routeError.status}: ${routeError.statusText || "Unknown route error"}`
    );
  }

  return new Error(String(routeError));
};

const REFRESH_REDIRECT_LOCATION = "__route_error_refresh__";

const RouteErrorFallback = () => {
  const navigate = useNavigate();
  const routeError = useRouteError();

  const handleRedirect = (redirectLocation: string) => {
    if (redirectLocation === REFRESH_REDIRECT_LOCATION) {
      window.location.reload();
      return;
    }

    navigate(redirectLocation);
  };

  useEffect(() => {
    errorMonitoring.sendError(routeErrorToError(routeError), span => {
      span.setAction("React Router Error Boundary");
      span.setTags({ framework: "React Router" });
    });
  }, [routeError]);

  return (
    <FullErrorPage
      errorMessage="Easil has experienced an unexpected error. Please refresh and try again."
      errorTitle="Oops. Looks like our wires are crossed."
      buttonMessage="Refresh"
      onRedirectTo={handleRedirect}
      redirectLocation={REFRESH_REDIRECT_LOCATION}
    />
  );
};

export default RouteErrorFallback;
